export default "__VITE_ASSET__31897103__"